import { render, staticRenderFns } from "./PropertiesMap.vue?vue&type=template&id=206de379"
import script from "./PropertiesMap.vue?vue&type=script&lang=js"
export * from "./PropertiesMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports